import { T } from "../../constants/theme";

function SectionTitle({ children }) {
  return (
    <div
      style={{
        fontSize: 11,
        letterSpacing: ".18em",
        textTransform: "uppercase",
        color: T.muted,
        fontWeight: 700,
        margin: "22px 0 10px",
      }}
    >
      {children}
    </div>
  );
}

function ChoiceButton({ active, onClick, children }) {
  return (
    <button
      onClick={onClick}
      style={{
        display: "block",
        width: "100%",
        textAlign: "left",
        padding: "9px 12px",
        marginBottom: 4,
        fontSize: 13,
        fontWeight: active ? 700 : 500,
        border: "none",
      
        background: active ? T.goldLight : "transparent",
        color: active ? T.ink : T.inkSoft,
        cursor: "pointer",
      }}
    >
      {children}
    </button>
  );
}

function Checkbox({ checked, onChange, label }) {
  return (
    <label
      style={{
        display: "flex",
        alignItems: "center",
        gap: 10,
        fontSize: 13,
        color: T.inkSoft,
        fontWeight: 500,
        cursor: "pointer",
        padding: "6px 0",
      }}
    >
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      {label}
    </label>
  );
}

export default function FilterSidebar({
  categories,
  brands,
  filters,
  setCategory,
  setBrand,
  setPriceMin,
  setPriceMax,
  setInStockOnly,
  setSaleOnly,
  setFeaturedOnly,
  onReset,
}) {
  return (
    <div
      style={{
        background: T.white,
        border: `1px solid ${T.border}`,
        
        padding: "22px 20px",
        height: "fit-content",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ fontSize: 15, fontWeight: 800, color: T.ink }}>Filters</div>
        <button
          onClick={onReset}
          style={{
            border: "none",
            background: "transparent",
            color: T.gold,
            fontSize: 12,
            fontWeight: 700,
            cursor: "pointer",
          }}
        >
          Reset Filters
        </button>
      </div>

      <SectionTitle>Categories</SectionTitle>
      <ChoiceButton active={!filters.category} onClick={() => setCategory("")}>
        All Categories
      </ChoiceButton>
      {categories.map((cat) => (
        <ChoiceButton
          key={cat.id || cat.slug}
          active={filters.category === cat.slug}
          onClick={() => setCategory(cat.slug)}
        >
          {cat.name}
        </ChoiceButton>
      ))}

      <SectionTitle>Brands</SectionTitle>
      <ChoiceButton active={!filters.brand} onClick={() => setBrand("")}>
        All Brands
      </ChoiceButton>
      {brands.map((b) => (
        <ChoiceButton key={b.id || b.slug} active={filters.brand === b.slug} onClick={() => setBrand(b.slug)}>
          {b.name}
        </ChoiceButton>
      ))}

      <SectionTitle>Price Range</SectionTitle>
      <div style={{ display: "flex", gap: 8 }}>
        <input
          type="number"
          min="0"
          placeholder="Min"
          value={filters.priceMin}
          onChange={(e) => setPriceMin(e.target.value)}
          style={{
            width: "50%",
            padding: "9px 10px",
            border: `1px solid ${T.border}`,
            borderRadius: 8,
            fontSize: 13,
          }}
        />
        <input
          type="number"
          min="0"
          placeholder="Max"
          value={filters.priceMax}
          onChange={(e) => setPriceMax(e.target.value)}
          style={{
            width: "50%",
            padding: "9px 10px",
            border: `1px solid ${T.border}`,
            borderRadius: 8,
            fontSize: 13,
          }}
        />
      </div>

      <SectionTitle>Availability</SectionTitle>
      <Checkbox checked={filters.inStockOnly} onChange={setInStockOnly} label="In Stock Only" />

      <SectionTitle>Collection</SectionTitle>
      <Checkbox checked={filters.featuredOnly} onChange={setFeaturedOnly} label="Featured" />
      <Checkbox checked={filters.saleOnly} onChange={setSaleOnly} label="Sale Items" />
    </div>
  );
}
